import {ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone} from '@angular/core';
import {ViewTabComponent} from '../viewtab.component';
import {ResourceService} from '../../resource.service';
import {CacheService} from '../../../cache/cache.service';
import {ErrorService} from '../../../error/error.service';
import {AbstractControlComponent, ControlTargetDontUpdateValue} from './abstract-control';
import {MATERIAL_ICONS} from './ctrl-icon.materialicons';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'ctrl-icon',
  templateUrl: './ctrl-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./ctrl-icon.component.scss'],
  standalone: false,
})
export class CtrlIconComponent extends AbstractControlComponent {
  ungroupedIcons: any;

  constructor(
    parent: ViewTabComponent,
    private resourceService: ResourceService,
    changeDetector: ChangeDetectorRef,
    private cacheService: CacheService,
    _ngZone: NgZone,
    errorService: ErrorService,
  ) {
    super(parent, null, null, changeDetector, _ngZone, errorService);
    this.ungroupedIcons = {};
    MATERIAL_ICONS.map(x => x.icons)
      .flat()
      .forEach(icon => (this.ungroupedIcons[icon.key] = icon.caption));
  }

  filteredIcons: Observable<{group: string; icons: {key: string; caption: string}[]}[]>;

  protected initMain() {
    super.initMain();

    this.filteredIcons = this.getValueChangedObs().pipe(
      startWith(''),
      map(searchTerm => {
        if (typeof searchTerm !== 'string' || searchTerm.length === 0) {
          return MATERIAL_ICONS;
        }

        searchTerm = searchTerm.toLowerCase();
        return MATERIAL_ICONS.map(group => {
          return {
            group: group.group,
            icons: group.icons.filter(
              icon =>
                icon.key.toLowerCase().includes(searchTerm) ||
                icon.caption.toLowerCase().includes(searchTerm),
            ),
          };
        }).filter(group => group.icons.length > 0);
      }),
    );
  }

  protected formatSource(source: any): any {
    source = super.formatSource(source);
    if (typeof source !== 'string') {
      return '';
    } else if (source in this.ungroupedIcons) {
      return {key: source, caption: this.ungroupedIcons[source]};
    } else {
      return source;
    }
  }

  protected formatTarget(value: any): any {
    if (typeof value === 'string') {
      return new ControlTargetDontUpdateValue();
    } else if (value != null && 'key' in value) {
      return value.key;
    } else {
      return super.formatTarget(value);
    }
  }

  getIconCaptionToKey(keyOrObj: any): string {
    if (keyOrObj == null || keyOrObj === '') {
      return '';
    }

    let key: string;
    if (typeof keyOrObj === 'object') {
      if ('caption' in keyOrObj) {
        return keyOrObj.caption;
      } else if ('key' in keyOrObj) {
        key = keyOrObj.key;
      } else {
        return '';
      }
    } else if (typeof keyOrObj === 'string') {
      key = keyOrObj;
    }
    if (
      key != null &&
      key !== '' &&
      this.ungroupedIcons != null &&
      Object.prototype.hasOwnProperty.call(this.ungroupedIcons, keyOrObj)
    ) {
      return this.ungroupedIcons[keyOrObj];
    }
    return '';
  }

  getIconForValue(value: any): string {
    if (typeof value === 'object' && value != null && 'key' in value) {
      return value.key;
    } else {
      return '';
    }
  }
}
